import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryHover } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	taxAmount: {
		fontWeight: 500,
	},
	link: {
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		fontSize: 'inherit',
		padding: 0,
		textDecoration: 'none',
		':hover': {
			color: brandPrimaryHover,
			textDecoration: 'underline',
		},
	},
	editLink: {
		fontSize: '0.875em',
	},
});
